/**
 * src/components/RoleLandingRedirect.tsx — send an authenticated user to
 * the right landing page for their role.
 *
 * Used on `/` so a driver who types the bare domain lands on
 * /driver/active instead of the customer dashboard they can't use.
 */

import { Navigate } from 'react-router-dom';
import { useCustomerRole } from '../hooks/useCustomerRole';
import { LoadingFallback } from './LoadingFallback';

export function RoleLandingRedirect() {
  const { role, loading } = useCustomerRole();
  if (loading) return <LoadingFallback />;
  if (role === 'driver' || role === 'both') return <Navigate to="/driver/home" replace />;
  if (role === 'admin') return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}
